import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import React, { useRef, useState } from 'react';
import styles from './SensitiveKeyword.module.scss';
import KeywordTab from './templates/keywords/KeywordTab';
import CustomMessagesTab from './templates/custom-messages/CustomMessagesTab';
import Tab from 'component/molecules/Tab/TabComponent';
import AddKeyword from 'component/organism/sensitive-keywords/AddKeyword';
import { useParams } from 'react-router-dom';
import { companyEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import { sensitiveKeywordsToast } from 'helpers/toastMessages';
import { useTour } from 'app-context/tourContext/TourContext';
import TourModal from 'component/hoc/tour-modal/TourModal';

const SensitiveKeyword = () => {
  const { id } = useParams();
  const ref = useRef(null);
  const [mode, setMode] = useState('add');
  const [refetch, setRefetch] = useState(false);
  const { showModal } = useTour();
  const { mutate: saveCustomMessages, isPending } = usePost({
    onSuccessToast: sensitiveKeywordsToast.editCustomMessage,
    toastType: 'update',
  });

  const handleSave = async () => {
    await ref.current.submitForm();

    const formIsValid = ref.current?.isValid;

    if (formIsValid) {
      saveCustomMessages(
        {
          url: companyEndpoints.setCompanyChatSettings(),
          data: {
            ...ref?.current?.values,
            botId: id,
          },
        },
        {
          onSuccess: () => {
            setRefetch((prev) => !prev);
          },
        }
      );
    }
  };
  const tabs = [
    {
      id: 1,
      label: 'Keywords',
      content: (
        <KeywordTab mode={mode} refetch={refetch} setRefetch={setRefetch} />
      ),
    },
    {
      id: 2,
      label: 'Custom Messages',
      content: <CustomMessagesTab ref={ref} id={id} isRefetch={refetch} />,
    },
  ];
  return (
    <>
      <SettingsHeader
        title="Sensitive Keyword"
        rightButtons={[
          ...(mode === 'add'
            ? []
            : [
                {
                  label: 'Save',
                  type: 'save',
                  func: handleSave,
                  isLoading: isPending,
                },
              ]),
        ]}
      />

      <Tab
        tabs={tabs}
        setPageTitle={(title) => {
          title === 'Keywords' ? setMode('add') : setMode(null);
        }}
        tabContentClass={styles['tab-class']}
      />

      {showModal && <TourModal />}
    </>
  );
};

export default SensitiveKeyword;
